import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const currentLanguage = (i18n.resolvedLanguage || i18n.language || 'es').split('-')[0];
  const isSpanish = currentLanguage === 'es';
  const buttonLabel = isSpanish ? 'EN' : 'ES';

  const toggleLanguage = () => {
    const targetLang = isSpanish ? 'en' : 'es';
    const path = location.pathname;
    const pathWithoutPrefix = path.startsWith('/en') ? path.replace(/^\/en/, '') || '/' : path;
    const newPath = targetLang === 'en' ? `/en${pathWithoutPrefix}` : pathWithoutPrefix;

    i18n.changeLanguage(targetLang);
    localStorage.setItem('language', targetLang);
    document.documentElement.lang = targetLang;
    navigate(newPath);
  };

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      aria-label={isSpanish ? 'Switch to English' : 'Cambiar a Español'}
      className="text-xs font-bold uppercase tracking-wider text-white/60 hover:text-white transition-colors duration-200"
      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px' }}
    >
      {buttonLabel}
    </button>
  );
};

export default LanguageSwitcher;
